import Formulario from "./components/Formulario";
import React ,{useState, useEffect} from 'react'
import Cita from "./components/Cita";


//📝Ultimo video: 5.12-MOSTRANDO_LAS_CITAS📝-------------------------


function App() {

  //citas en local storage
  let citasIniciales= JSON.parse(localStorage.getItem('citas'));
  //prbando Storage
  

  if (!citasIniciales) {
    citasIniciales=[];
  }


  //Arreglo de Citas
  const [citas, setCitas] = useState(citasIniciales);

//useEffect para realizar ciertas operaciones cuando el state cambia  Siempre es un arrow Func =>

  useEffect( ()=>{
   if (citas) {
     
 
     localStorage.setItem("citas", JSON.stringify(citas))
     
   }else{
     localStorage.setItem("citas", JSON.stringify([]))
   }
  },[citas]);



  //Funcion que Elimina una cita por su Id

  const eliminarCita = id =>{

    console.log(id);
    const nuevasCitas = citas.filter(cita=>cita.id !==id)

    setCitas(nuevasCitas);

  }



  //Probando el State
  const [Contador, setContador] = useState(0);
  
  const [Propietarios, setPropietarios] = useState([]);


//Funcion que tome las citas actuales y agregue la nueva
const crearCita= cita =>{
  
  setCitas([
    ...citas,
    
    cita
  ]);

  //console.log(citas);

  setContador(Contador+1)
  
  //Consolas, 'Courier New', monospace

  setPropietarios([
    ...Propietarios,
    cita.propietario,
    
    
  ]);
  


}
  //Textos usando Condicionales
  const titulo = citas.length=== 0 ? "No hay Citas": "Administra tus Citas"
  //console.log(citas.length);
  
  return (
    <div className="App">
       
        <h1>Centro  Clinico Puppyhut  🐶 </h1>
      

        <div className="container">
          <div className="row">
            <div className="one-half column">
            <Formulario
              crearCita ={crearCita}
              />
            </div>

            <div className="one-half column">
              <h2>{titulo}</h2>
              {citas.map(cita =>(
               <Cita
                 cita={cita}
                 key= {cita.id}
                 eliminarCita= {eliminarCita}
                />
              ))}

            </div>

          </div>
        </div>
    </div>
  );
}

export default App;
